module.exports = __webpack_public_path__ + "static/media/arrows.70292920.svg";